import React from "react";

import destination_1 from "../../public/wheretogo-sumava/boubin/destination_1.png";
import destination_2 from "../../public/wheretogo-sumava/boubin/destination_2.png";
import destination_3 from "../../public/wheretogo-sumava/boubin/destination_3.png";
import destination_4 from "../../public/wheretogo-sumava/boubin/destination_4.png";
import destination_5 from "../../public/wheretogo-sumava/boubin/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-sumava/boubin/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-sumava/boubin/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-sumava/boubin/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-sumava/boubin/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Boubin = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Boubín</h1>
            <p>
              Boubín (1362) je nejvyšší bod mohutného horského masívu Boubínské
              hornatiny. Je neodmyslitelným symbolem Šumavy nejen svým tvarem a
              výškou, ale i rozsáhlými lesy a zejména pralesní rezervací
              Boubínský prales. Ta je jednou z nejvzácnějších ukázek nedotčené
              přírody ve střední Evropě.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>rozhledna</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>boubínský prales</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>1362 m. n. m.</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>výhled na Alpy</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Výška věže na Poledníku činí 37 metrů. Kolem jejího vrcholu
                  byl vybudován ochoz, z nějž se můžete pokochat šumavskými
                  panoramaty. Drátěná plošina na jedné straně věže pak umožňuje
                  pohled přímo pod sebe do hloubky 34 metrů.
                </li>
                <li>
                  Velmi zajímavý je ovšem výhled na Boubínský prales, který se
                  strukturou zřetelně odlišuje od okolních monokulturních lesů.
                </li>
                <li>
                  Na vrcholu je také chráněný trigonometrický bod I. řádu a malý
                  obelisk na paměť návštěvy pražského arcibiskupa.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Boubin;
